/**
 * Created by shani on 28/06/17.
 */
export class Login {
    constructor(
        public userName: string,
        public userPassword: string,
        public captchaResponse: string,
        public selectedUserId: string,
        public entityType: string,
        public newPassword: string,
        public rePassword: string,
        public userPhone: string,
        public verificationCode: string,
        public isAdmin: boolean,
    ){}
}
